import { format, parseISO, setHours, setMilliseconds, setMinutes, setSeconds } from '../date';
/**
 * Normalizes the date and time.
 * The day remains consistent across time zones, with the final result always representing 8:00 PM UTC.
 *
 * This ensures the date is timezone-agnostic, preventing shifts caused by different user time zones.
 * - Sets the time to 8:00 PM local time.
 * - Adjusts by the local timezone offset to align with UTC.
 */
export const normalizeDateTime = (dateInput) => {
    const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;
    const localOffset = new Date().getTimezoneOffset();
    const dateWith8PM = setMilliseconds(setSeconds(setMinutes(setHours(date, 20), 0), 0), 0);
    dateWith8PM.setMinutes(dateWith8PM.getMinutes() - localOffset);
    return dateWith8PM;
};
/**
 * Format localized date and time e.g. 2023-10-01, 12:00 AM
 */
export const formatDateTime = (date) => {
    if (!date)
        return null;
    if (typeof date === 'string') {
        return format(parseISO(date), 'yyyy-MM-dd, KK:mm aaaa');
    }
    return format(date, 'yyyy-MM-dd, KK:mm aaaa');
};
/**
 * Format localized date e.g. 2023-10-01
 */
export const formatDate = (date) => {
    if (!date)
        return null;
    if (typeof date === 'string') {
        return format(parseISO(date), 'yyyy-MM-dd');
    }
    return format(date, 'yyyy-MM-dd');
};
export const formatTime = (date) => {
    if (!date)
        return null;
    if (typeof date === 'string') {
        return format(parseISO(date), 'KK:mm aaaa');
    }
    return format(date, 'KK:mm aaaa');
};
export const formatIsoDate = (date) => {
    if (!date)
        return null;
    if (typeof date === 'string') {
        return format(parseISO(date), 'yyyy-MM-dd');
    }
    return format(date, 'yyyy-MM-dd');
};
export const formatUtcIsoDateTime = (date) => {
    return date.toISOString();
};
